import { useSearchParams, Navigate, useLocation } from 'react-router-dom'
import PrefixedText from 'components/common/PrefixedText/PrefixedText'
import Edit from 'components/assets/icons/Edit'
import Link from 'components/common/Link/Link'
import { pages } from 'components/RCPro/helpers/nav'
import style from './Oups.module.scss'

const RCProOups = () => {
  const { state } = useLocation()
  const [ searchParams ] = useSearchParams()
  const reason = searchParams.get('reason')
  const { oups } = state.texts
  const previous = JSON.parse(localStorage.getItem('RCPro'))

  const reasons = [
    {
      reason: 'no-company',
      title: oups.title1,
      content: oups.reason1,
      backto: previous.page === 'estimate' ? 6 : 2
    },
    {
      reason: 'activity',
      title: oups.title2,
      content: oups.reason2,
      backto: previous.page === 'estimate' ? 6 : 3
    },
    {
      reason: 'origin',
      title: oups.title3,
      content: oups.reason3,
      backto: previous.page === 'estimate' ? 6 : 4
    }
  ]

  const item = reasons.find( elm => elm.reason === reason )

  return !item
    ? <Navigate to="../404" replace />
    : <div className={style.content}>
      <h1>{item.title} 👀</h1>
      <p>{item.content}</p>

      <Link
        className={style.link}
        label={
          <PrefixedText
            prefix={<Edit />}
            text={oups.button}
          />
        }
        to={'../'+pages[item.backto]}
        state={state}
      />
    </div>
}

export default RCProOups